import { render, staticRenderFns } from "./ReportImageRegistration.vue?vue&type=template&id=68c80167"
import script from "./ReportImageRegistration.vue?vue&type=script&lang=ts"
export * from "./ReportImageRegistration.vue?vue&type=script&lang=ts"
import style0 from "./ReportImageRegistration.vue?vue&type=style&index=0&id=68c80167&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports